/*
 * P Promo Core — lớp đọc dữ liệu khuyến mãi cho theme Polomanor.
 *
 * Gom TOÀN BỘ chỗ đụng vào BOGOS (window.FGSECOMAPP) vào một file.
 * Nếu app đổi cấu trúc dữ liệu thì chỉ sửa ở đây, các UI khác không cần biết.
 *
 * Nguyên tắc:
 *  - Không dùng requestAnimationFrame để chờ phần tử/dữ liệu (rAF ngừng chạy
 *    khi tab không compositing). Chỉ dùng setTimeout.
 *  - Fail-safe: không có BOGOS thì mọi getter trả rỗng, UI tự ẩn, không văng lỗi.
 *
 * API: window.PPromo
 */
(function () {
  'use strict';
  if (window.__pPromoInit) return;
  window.__pPromoInit = true;

  var CFG = window.PPromoConfig || {};

  // Các giá trị `type` của discount BOGOS được coi là "flash sale".
  // BOGOS không phơi enum ra storefront nên liệt kê rộng + cho phép match theo tiêu đề.
  var FLASH_TYPES = CFG.flashTypes || ['product', 'product_discount', 'flash', 'flash_sale', 'cheapest'];
  var FLASH_TITLE_RE = CFG.flashTitlePattern ? new RegExp(CFG.flashTitlePattern, 'i') : /flash\s*sale/i;

  var _cart = null;       // cache /cart.js gần nhất
  var _cartAt = 0;
  var _listeners = [];
  var _readyCbs = [];
  var _ready = false;
  var _changeTimer = null;

  /* ------------------------------------------------------------------ *
   * Tiện ích
   * ------------------------------------------------------------------ */

  function fg() {
    return window.FGSECOMAPP || null;
  }

  function available() {
    return !!fg();
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // cents (đơn vị Shopify) -> "329.000đ"
  function money(cents) {
    return Math.round((Number(cents) || 0) / 100).toLocaleString('vi-VN') + 'đ';
  }

  // VND thực -> "329.000đ"
  function moneyVnd(dong) {
    return Math.round(Number(dong) || 0).toLocaleString('vi-VN') + 'đ';
  }

  function toMs(value) {
    if (!value) return null;
    if (typeof value === 'number') return value < 1e12 ? value * 1000 : value;
    // BOGOS trả ISO ("2026-08-06T12:00:00.000000Z") hoặc "YYYY-MM-DD HH:mm:ss"
    var s = String(value).trim().replace(' ', 'T');
    // cắt microsecond dư (JS chỉ hiểu 3 chữ số mili)
    s = s.replace(/(\.\d{3})\d+/, '$1');
    if (!/Z|[+-]\d{2}:?\d{2}$/.test(s)) s += 'Z';
    var ms = Date.parse(s);
    return isNaN(ms) ? null : ms;
  }

  function toArray(v) {
    if (!v) return [];
    if (Array.isArray(v)) return v;
    if (typeof v === 'object') {
      return Object.keys(v).map(function (k) { return v[k]; });
    }
    return [];
  }

  /* ------------------------------------------------------------------ *
   * Chuẩn hoá dữ liệu discount BOGOS
   * ------------------------------------------------------------------ */

  /**
   * Rút mục tiêu từ `condition.products` của BOGOS.
   *
   * Hai dạng đã gặp thật trên store:
   *   - type "variants_ids"        → value = { <productId>: { id, variants:[{id,...}] } }
   *   - type "product_collections" → value  = { <collectionId>: "<tên collection>" }
   *                                  handle = { <collectionId>: "<handle>" }
   *     (KHÔNG kèm danh sách sản phẩm — muốn biết SP nào thuộc collection thì
   *      phải để Liquid render ra, xem section p-flash-sale.)
   */
  function targetsFromCondition(condition) {
    var productIds = [];
    var variantIds = [];
    var collectionIds = [];
    var collectionTitles = {};
    var collectionHandles = [];

    var empty = {
      productIds: productIds,
      variantIds: variantIds,
      collectionIds: collectionIds,
      collectionTitles: collectionTitles,
      collectionHandles: collectionHandles
    };
    if (!condition) return empty;

    toArray(condition.products).forEach(function (entry) {
      if (!entry || entry.filter_option === 'exclude') return;

      if (entry.type === 'product_collections') {
        var val = entry.value || {};
        var handles = entry.handle || {};
        Object.keys(val).forEach(function (cid) {
          collectionIds.push(Number(cid));
          if (typeof val[cid] === 'string') collectionTitles[cid] = val[cid];
          if (handles[cid]) collectionHandles.push(handles[cid]);
        });
        return;
      }

      toArray(entry.value).forEach(function (p) {
        if (!p || typeof p !== 'object') return;
        if (p.id) productIds.push(Number(p.id));
        toArray(p.variants).forEach(function (v) {
          if (v && v.id) variantIds.push(Number(v.id));
        });
      });
    });

    return empty;
  }

  // `discount` có thể là 1 object {type,value} hoặc mảng tier [{quantity, discount:{...}}]
  function tiersFrom(raw) {
    var out = [];
    if (!raw) return out;

    if (Array.isArray(raw)) {
      raw.forEach(function (t) {
        var d = t && (t.discount || t);
        if (!d) return;
        out.push({
          quantity: Number(t.quantity) || 1,
          title: t.title || '',
          tag: t.tag || '',
          type: d.type || '',
          value: Number(d.value) || 0
        });
      });
      return out;
    }

    if (typeof raw === 'object') {
      out.push({
        quantity: 1,
        title: '',
        tag: '',
        type: raw.type || '',
        value: Number(raw.value) || 0
      });
    }
    return out;
  }

  function normalizeDiscount(d) {
    if (!d) return null;
    var targets = targetsFromCondition(d.condition);
    return {
      id: d.id,
      type: d.type || '',
      title: d.title || d.name || '',
      subTitle: d.sub_title || '',
      label: d.label || '',
      startsAt: toMs(d.start_time),
      endsAt: toMs(d.end_time),
      recurring: d.recurring_status ? (d.recurring || null) : null,
      tiers: tiersFrom(d.discount),
      productIds: targets.productIds,
      variantIds: targets.variantIds,
      collectionIds: targets.collectionIds,
      collectionTitles: targets.collectionTitles,
      collectionHandles: targets.collectionHandles,
      shopifyDiscountId: d.shopify_discount_id || null,
      raw: d
    };
  }

  function isActive(d, now) {
    now = now || Date.now();
    if (d.startsAt && now < d.startsAt) return false;
    if (d.endsAt && now > d.endsAt) return false;
    return true;
  }

  /* ------------------------------------------------------------------ *
   * Khung giờ lặp theo ngày (BOGOS "recurring")
   *
   * Với flash sale, start_time/end_time chỉ là khoảng CHIẾN DỊCH
   * (vd 31/07 → 31/08). Giờ chạy thật nằm trong `recurring`:
   *   { timezone: "+07:00", frequency: "daily",
   *     start_time_in_day: "15:00", end_time_in_day: "16:59" }
   * Phải tính theo timezone của cửa hàng, không theo timezone máy khách.
   * ------------------------------------------------------------------ */

  function tzOffsetMs(tz) {
    var m = /^([+-])(\d{2}):?(\d{2})$/.exec(String(tz || '').trim());
    if (!m) return null;
    return (m[1] === '-' ? -1 : 1) * ((+m[2]) * 3600000 + (+m[3]) * 60000);
  }

  // Khung giờ của "hôm nay" (theo timezone cửa hàng), trả về mốc UTC ms.
  function dailyWindow(rec, nowMs, dayShift) {
    var off = tzOffsetMs(rec.timezone);
    if (off == null) off = -new Date().getTimezoneOffset() * 60000;

    var shifted = new Date(nowMs + off);
    var y = shifted.getUTCFullYear();
    var mo = shifted.getUTCMonth();
    var day = shifted.getUTCDate() + (dayShift || 0);

    function at(hhmm) {
      var p = String(hhmm || '00:00').split(':');
      return Date.UTC(y, mo, day, parseInt(p[0], 10) || 0, parseInt(p[1], 10) || 0, 0) - off;
    }

    var start = at(rec.start_time_in_day);
    var end = at(rec.end_time_in_day);
    if (end <= start) end += 86400000; // khung vắt qua nửa đêm
    return { start: start, end: end };
  }

  /**
   * Lượt chạy hiện tại / kế tiếp của một discount.
   * @returns {Object} { state: 'running'|'upcoming'|'ended', startsAt, endsAt }
   */
  function occurrence(d, now) {
    now = now || Date.now();

    // Ngoài khoảng chiến dịch thì thôi
    if (d.endsAt && now > d.endsAt) return { state: 'ended', startsAt: d.startsAt, endsAt: d.endsAt };

    if (!d.recurring || !d.recurring.start_time_in_day) {
      if (d.startsAt && now < d.startsAt) return { state: 'upcoming', startsAt: d.startsAt, endsAt: d.endsAt };
      return { state: 'running', startsAt: d.startsAt, endsAt: d.endsAt };
    }

    var today = dailyWindow(d.recurring, now, 0);

    if (now >= today.start && now <= today.end) {
      return { state: 'running', startsAt: today.start, endsAt: today.end };
    }

    var next = now < today.start ? today : dailyWindow(d.recurring, now, 1);

    // Lượt kế tiếp rơi ra ngoài ngày kết thúc chiến dịch
    if (d.endsAt && next.start > d.endsAt) {
      return { state: 'ended', startsAt: next.start, endsAt: next.end };
    }

    return { state: 'upcoming', startsAt: next.start, endsAt: next.end };
  }

  /* ------------------------------------------------------------------ *
   * Getters công khai
   * ------------------------------------------------------------------ */

  function getDiscounts() {
    var F = fg();
    if (!F) return [];
    return toArray(F.discounts).map(normalizeDiscount).filter(Boolean);
  }

  function looksLikeFlash(d) {
    if (d.type && FLASH_TYPES.indexOf(String(d.type).toLowerCase()) !== -1) return true;
    if (d.title && FLASH_TITLE_RE.test(d.title)) return true;
    return false;
  }

  /* ------------------------------------------------------------------ *
   * Nhớ lịch Flash Sale
   *
   * BOGOS CHỈ đẩy discount Flash Sale ra storefront TRONG lúc khung giờ đang
   * mở. Ngoài khung thì `FGSECOMAPP.discounts` không có dòng nào — đã đo trực
   * tiếp lúc 14:51 VN: 8 discount, tất cả type "volume", không có flash.
   * Vì vậy không thể đếm ngược tới giờ mở bằng dữ liệu sống.
   *
   * Cách vá: lúc khung giờ ĐANG mở, BOGOS có gửi kèm `recurring`
   * (start_time_in_day / end_time_in_day / timezone). Ghi lại vào
   * localStorage, rồi lúc BOGOS im lặng thì tự tính khung kế tiếp từ lịch đã
   * nhớ. Tự cập nhật mỗi lần sale chạy — không phải khai báo giờ bằng tay.
   *
   * Giới hạn phải biết:
   *  - Khách chưa từng vào web trong lúc có sale thì chưa có lịch → chưa hiện
   *    trước được. Từ lần sau là có.
   *  - Đổi lịch trong BOGOS thì bản nhớ còn cũ cho tới khung đầu tiên của lịch
   *    mới → hết hạn sau 7 ngày, và dữ liệu SỐNG luôn thắng dữ liệu nhớ.
   * ------------------------------------------------------------------ */

  /**
   * Lịch khai báo TAY trong section "P Promo — Nền khuyến mãi", gõ đúng khung
   * giờ đã đặt bên BOGOS. CHỈ dùng cho việc hiện trước (đếm ngược tới giờ mở).
   * Việc hiện Flash Sale trong khung giờ vẫn hoàn toàn dựa vào dữ liệu sống
   * của BOGOS — lịch tay không bao giờ bật một đợt "đang chạy".
   *
   * Định dạng: "08:00-12:59, 15:00-16:59, 19:00-20:59"
   */
  function configWindows() {
    var cfg = (window.PPromoConfig && window.PPromoConfig.flashSchedule) || null;
    if (!cfg || !cfg.windows) return [];

    var tz = cfg.timezone || '+07:00';
    var until = cfg.until ? toMs(cfg.until) : null;
    if (until && Date.now() > until) return [];

    return String(cfg.windows)
      .split(',')
      .map(function (s) {
        var m = String(s).trim().match(/^(\d{1,2}:\d{2})\s*[-–]\s*(\d{1,2}:\d{2})$/);
        if (!m) return null;
        return {
          recurring: {
            timezone: tz,
            frequency: 'daily',
            start_time_in_day: m[1],
            end_time_in_day: m[2]
          },
          campaignEnd: until
        };
      })
      .filter(Boolean);
  }

  /**
   * Dựng "đợt sắp mở" GẦN NHẤT từ lịch khai báo tay, khi dữ liệu sống không có.
   * Cố ý KHÔNG có `tiers` — chưa tới giờ thì chưa có giá giảm để vẽ, và
   * getFlashPrice sẽ trả null nên card giữ nguyên giá gốc.
   *
   * Nếu lịch tay nói "đang trong khung" mà BOGOS lại im lặng thì trả null:
   * không bịa ra một đợt đang chạy khi không biết mức giảm. Giờ chạy thật
   * luôn do BOGOS quyết định.
   */
  function scheduledUpcoming(now, within) {
    var best = null;
    var c = null;

    configWindows().forEach(function (s) {
      var occ = occurrence(
        { recurring: s.recurring, startsAt: null, endsAt: s.campaignEnd || null },
        now
      );
      if (occ.state !== 'upcoming') return;
      if (within && (occ.startsAt - now) > within) return;
      if (!best || occ.startsAt < best.startsAt) { best = occ; c = s; }
    });

    if (!best) return null;
    var occ = best;

    return {
      id: c.id,
      type: c.type || '',
      title: c.title || '',
      subTitle: '',
      label: '',
      state: 'upcoming',
      startsAt: occ.startsAt,
      endsAt: occ.endsAt,
      recurring: c.recurring,
      tiers: [],
      productIds: c.productIds || [],
      variantIds: c.variantIds || [],
      collectionIds: c.collectionIds || [],
      collectionTitles: [],
      collectionHandles: c.collectionHandles || [],
      shopifyDiscountId: null,
      fromSchedule: true, // đánh dấu: dựng từ lịch nhớ, không phải dữ liệu sống
      raw: null
    };
  }

  /**
   * Flash sale đang chạy hoặc sắp chạy.
   * @param {Object} [opts] { includeUpcoming: true, upcomingWithinMs: 86400000 }
   */
  function getFlashSales(opts) {
    opts = opts || {};
    var now = Date.now();
    var within = opts.upcomingWithinMs == null ? 86400000 : opts.upcomingWithinMs;
    var includeUpcoming = opts.includeUpcoming !== false;

    var live = getDiscounts()
      .filter(looksLikeFlash)
      .map(function (d) {
        var occ = occurrence(d, now);
        d.state = occ.state;
        // startsAt/endsAt = LƯỢT CHẠY, không phải khoảng chiến dịch — đây là
        // con số dùng cho đồng hồ đếm ngược.
        d.startsAt = occ.startsAt;
        d.endsAt = occ.endsAt;
        return d;
      })
      .filter(function (d) {
        if (d.state === 'running') return true;
        if (d.state !== 'upcoming' || !includeUpcoming) return false;
        return !within || (d.startsAt - now) <= within;
      })
      .sort(function (a, b) { return (a.startsAt || 0) - (b.startsAt || 0); });

    if (live.length || !includeUpcoming) return live;

    // Không có dữ liệu sống → thử dựng "sắp mở" từ lịch khai báo tay.
    var sched = scheduledUpcoming(now, within);
    return sched ? [sched] : [];
  }

  /** Flash sale đang chạy ngay lúc này (hoặc null). */
  function getCurrentFlashSale() {
    var list = getFlashSales({ includeUpcoming: false });
    return list.length ? list[0] : null;
  }

  /**
   * Discount đang chạy áp cho 1 sản phẩm/variant.
   *
   * @param {Number} variantId
   * @param {Number} productId
   * @param {Array}  [inCollectionIds] id các collection sản phẩm thuộc về —
   *        BẮT BUỘC truyền khi discount nhắm theo collection, vì BOGOS không
   *        gửi kèm danh sách sản phẩm của collection ra storefront.
   */
  function findFlashFor(variantId, productId, inCollectionIds) {
    var list = getFlashSales({ includeUpcoming: false });
    var mine = (inCollectionIds || []).map(Number);

    for (var i = 0; i < list.length; i++) {
      var d = list[i];

      if (variantId && d.variantIds.indexOf(Number(variantId)) !== -1) return d;
      if (productId && d.productIds.indexOf(Number(productId)) !== -1) return d;

      if (d.collectionIds.length) {
        for (var j = 0; j < mine.length; j++) {
          if (d.collectionIds.indexOf(mine[j]) !== -1) return d;
        }
        continue; // có nhắm collection nhưng không khớp -> không áp
      }

      // Không nhắm gì cả => áp toàn store
      if (!d.variantIds.length && !d.productIds.length) return d;
    }
    return null;
  }

  /**
   * Giá sau flash sale của 1 variant.
   * @param {Number} priceCents giá gốc (cents)
   * @returns {Object|null} { price, saved, discount }
   */
  function getFlashPrice(priceCents, variantId, productId, inCollectionIds) {
    var d = findFlashFor(variantId, productId, inCollectionIds);
    if (!d || !d.tiers.length) return null;

    var tier = d.tiers[0];
    var price = Number(priceCents) || 0;
    var out = price;

    switch (String(tier.type)) {
      case 'percentage':
      case 'percent':
        out = price - Math.round(price * tier.value / 100);
        break;
      case 'fixed_amount':
      case 'amount':
        out = price - tier.value * 100; // BOGOS lưu VND thực
        break;
      case 'fixed_price':
        out = tier.value * 100;
        break;
      default:
        return null;
    }

    if (out < 0) out = 0;
    if (out >= price) return null;
    return { price: out, saved: price - out, discount: d };
  }

  /** Combo volume (mua nhiều giảm sâu) áp cho 1 sản phẩm. */
  function getVolumeFor(productId) {
    productId = Number(productId);
    var now = Date.now();
    return getDiscounts().filter(function (d) {
      return d.type === 'volume' && isActive(d, now) && d.productIds.indexOf(productId) !== -1;
    });
  }

  /** Bundle / Mix & Match do BOGOS cấu hình. */
  function getBundles() {
    var F = fg();
    if (!F) return [];
    return toArray(F.bundles);
  }

  function getMixMatchFor(productId) {
    productId = Number(productId);
    return getBundles().filter(function (b) {
      var t = targetsFromCondition(b && b.condition);
      return t.productIds.indexOf(productId) !== -1;
    });
  }

  /**
   * Các mốc quà tặng theo giá trị đơn.
   * @returns {Array} [{ id, title, min, max, gifts:[{title,image}], reached, remaining }]
   */
  function getGiftTiers() {
    var F = fg();
    if (!F) return [];
    var subtotal = getBuySubtotal(); // VND thực

    return toArray(F.offers).map(function (o) {
      var cond = toArray(o.offer_conditions)[0] || {};
      var min = Number(cond.min_amount) || 0;
      var max = cond.max_amount == null ? null : Number(cond.max_amount);
      var gifts = toArray(o.gift_products).map(function (g) {
        return {
          title: g.title || g.product_title || '',
          image: g.image || (g.images && g.images[0]) || '',
          handle: g.handle || ''
        };
      });
      return {
        id: o.id,
        title: o.offer_name || o.title || '',
        min: min,
        max: max,
        unit: cond.unit || 'money',
        gifts: gifts,
        reached: subtotal >= min,
        remaining: Math.max(0, min - subtotal)
      };
    }).sort(function (a, b) { return a.min - b.min; });
  }

  /* ------------------------------------------------------------------ *
   * Giỏ hàng
   * ------------------------------------------------------------------ */

  /**
   * Dòng quà tặng do BOGOS thêm.
   *
   * Trên store này BOGOS dùng SẢN PHẨM CLONE giá 0đ (handle kết thúc bằng
   * `sca_clone_freegift`), nên original_line_price CŨNG bằng 0 — không thể chỉ
   * dựa vào "final < original". Kiểm tra theo thứ tự: property đánh dấu →
   * handle clone → giá 0.
   */
  function isGiftLine(item) {
    if (!item) return false;

    var props = item.properties || {};
    for (var k in props) {
      if (/^_(fg|bogos|pp)_?gift/i.test(k)) return true;
    }

    if (/(sca_clone_freegift|_freegift)$/i.test(item.handle || '')) return true;

    if (item.final_line_price === 0) return true;

    return false;
  }

  function cartSync() {
    if (_cart) return _cart;
    try {
      var st = window.scaCart && window.scaCart.getState ? window.scaCart.getState() : null;
      if (st && st.cart) return st.cart;
    } catch (e) {}
    return null;
  }

  /** Tổng tiền hàng KHÁCH MUA (loại dòng quà), tính bằng VND thực. */
  function getBuySubtotal() {
    var cart = cartSync();
    if (!cart || !cart.items) return 0;
    var sum = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (isGiftLine(it)) continue;
      sum += Number(it.original_line_price || it.line_price || 0);
    }
    return Math.round(sum / 100);
  }

  function getCart(force) {
    if (!force && _cart && Date.now() - _cartAt < 1500) {
      return Promise.resolve(_cart);
    }
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { _cart = c; _cartAt = Date.now(); return c; })
      .catch(function () { return _cart; });
  }

  function setCart(cart) {
    if (cart) { _cart = cart; _cartAt = Date.now(); }
  }

  /* ------------------------------------------------------------------ *
   * Đếm ngược
   * ------------------------------------------------------------------ */

  /**
   * Đếm ngược tới mốc thời gian, tự tính lại theo Date.now() nên không lệch
   * khi tab bị ngủ. Trả về hàm stop().
   */
  function countdown(targetMs, cb) {
    if (!targetMs || typeof cb !== 'function') return function () {};
    var timer = null;
    var stopped = false;

    function tick() {
      if (stopped) return;
      var left = targetMs - Date.now();
      if (left <= 0) {
        cb({ days: 0, hours: 0, minutes: 0, seconds: 0, total: 0, done: true });
        stop();
        return;
      }
      var s = Math.floor(left / 1000);
      cb({
        days: Math.floor(s / 86400),
        hours: Math.floor(s / 3600) % 24,
        minutes: Math.floor(s / 60) % 60,
        seconds: s % 60,
        total: left,
        done: false
      });
    }

    function stop() {
      stopped = true;
      if (timer) clearInterval(timer);
      timer = null;
      document.removeEventListener('visibilitychange', onVis);
    }

    function onVis() {
      if (!document.hidden) tick();
    }

    tick();
    timer = setInterval(tick, 1000);
    document.addEventListener('visibilitychange', onVis);
    return stop;
  }

  function pad2(n) {
    return (n < 10 ? '0' : '') + n;
  }

  /* ------------------------------------------------------------------ *
   * Vòng đời / sự kiện
   * ------------------------------------------------------------------ */

  function emitChange() {
    if (_changeTimer) clearTimeout(_changeTimer);
    _changeTimer = setTimeout(function () {
      _changeTimer = null;
      for (var i = 0; i < _listeners.length; i++) {
        try { _listeners[i](); } catch (e) {}
      }
    }, 120);
  }

  function onChange(cb) {
    if (typeof cb === 'function') _listeners.push(cb);
    return function off() {
      var i = _listeners.indexOf(cb);
      if (i !== -1) _listeners.splice(i, 1);
    };
  }

  function markReady() {
    if (_ready) return;
    _ready = true;
    var cbs = _readyCbs.slice();
    _readyCbs.length = 0;
    for (var i = 0; i < cbs.length; i++) {
      try { cbs[i](available()); } catch (e) {}
    }
  }

  /**
   * Gọi cb khi dữ liệu BOGOS sẵn sàng. Nếu quá hạn chờ vẫn gọi cb(false)
   * để UI tự quyết định ẩn đi thay vì treo vô hạn.
   */
  function ready(cb) {
    if (typeof cb !== 'function') return;
    if (_ready) { cb(available()); return; }
    _readyCbs.push(cb);
  }

  // Poll bằng setTimeout — KHÔNG dùng rAF (rAF ngừng khi tab không compositing).
  function waitForBogos(tries) {
    if (available()) { markReady(); return; }
    if (tries <= 0) { markReady(); return; }
    setTimeout(function () { waitForBogos(tries - 1); }, 250);
  }

  var BOGOS_EVENTS = [
    'fg-app:end',
    'bogos:cart-updated',
    'fg-gifts:updated',
    'fg-cart:auto-updated',
    'bogos:discount-added',
    'bogos:product-discount-render',
    'bogos:volume-render'
  ];

  function start() {
    BOGOS_EVENTS.forEach(function (name) {
      document.addEventListener(name, function () {
        if (name === 'fg-app:end') markReady();
        emitChange();
      });
    });

    document.addEventListener('on:cart:loaded', function () {
      _cart = null;
      emitChange();
    });

    // Store giỏ hàng của theme (Venue / Zustand)
    (function attachStore(tries) {
      if (window.scaCart && window.scaCart.subscribe) {
        try {
          window.scaCart.subscribe(function () { _cart = null; emitChange(); });
        } catch (e) {}
        return;
      }
      if (tries > 0) setTimeout(function () { attachStore(tries - 1); }, 300);
    })(20);

    waitForBogos(40); // ~10s
  }

  window.PPromo = {
    available: available,
    ready: ready,
    onChange: onChange,
    refresh: emitChange,

    // dữ liệu
    getDiscounts: getDiscounts,
    getFlashSales: getFlashSales,
    occurrence: occurrence,
    getCurrentFlashSale: getCurrentFlashSale,
    getFlashPrice: getFlashPrice,
    findFlashFor: findFlashFor,
    getVolumeFor: getVolumeFor,
    getBundles: getBundles,
    getMixMatchFor: getMixMatchFor,
    getGiftTiers: getGiftTiers,

    // giỏ hàng
    getCart: getCart,
    setCart: setCart,
    cartSync: cartSync,
    isGiftLine: isGiftLine,
    getBuySubtotal: getBuySubtotal,

    // tiện ích
    esc: esc,
    money: money,
    moneyVnd: moneyVnd,
    pad2: pad2,
    toMs: toMs,
    countdown: countdown
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
